import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'User',
    column_type: 'id',
  },
  created_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'User',
    column_type: 'datetime',
  },
  screen_name: {
    model_name: 'User',
    column_type: 'string',
  },
  is_block: {
    model_name: 'User',
    column_type: 'boolean',
  },
  profile: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'profile',
      model_name: 'Profile',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'invite_relationship',
      model_name: 'InviteRelationship',
      foreign_key: 'user_id',
    },
  },
  sns_authorized: {
    model_name: 'User',
    column_type: 'string',
  },
  like_posts_count: {
    model_name: 'User',
    column_type: 'integer',
  },
  star_posts_count: {
    model_name: 'User',
    column_type: 'integer',
  },
  view_posts_count: {
    model_name: 'User',
    column_type: 'integer',
  },
  share_posts_count: {
    model_name: 'User',
    column_type: 'integer',
  },
  invitees_count: {
    model_name: 'User',
    column_type: 'string',
  },
  avatar: {
    model_name: 'User',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  parent_user: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'parent_user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  student: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'student',
      model_name: 'Student',
      foreign_key: 'user_id',
    },
  },
  member: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'member',
      model_name: 'Member',
      foreign_key: 'user_id',
    },
  },
  invite_relationship: {
    model_name: 'User',
    column_type: 'has_one',
    extra: {
      polymorphic: '',
      association_name: 'invite_relationship',
      model_name: 'InviteRelationship',
      foreign_key: 'user_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
